import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import EventCardSimple from 'components/Event/EventCardSimple';
import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { withRouter } from 'react-router-dom';
// import AppBar from "@material-ui/core/AppBar";
// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
import Paper from '@material-ui/core/Paper';
import gotoLiveRoom from 'helpers/gotoLiveRoom';
import WarningIcon from '@material-ui/icons/Warning';
import Template from 'components/Template/Template';
import {
  fetchData,
  getDataHome,
  // getLoadingError
} from '../../ducks/asyncFetcher';
import { getCurrentUser, isStateKnown } from '../../ducks/authentication';
import { TabPanel } from '../UI/Tab/TabPanel';
import i18n from 'helpers/i18n';
import getMyLiveEvents from 'helpers/getMyLiveEvents';
import getMyPastEvents from 'helpers/getMyPastEvents';
import getMySubscriptions from 'helpers/getMySubscriptions';
import getAvailableEventsByTheme from 'helpers/getAvailableEventsByTheme';
import getAvailableEventsByReference from 'helpers/getAvailableEventsByReference';
const styles = (theme) => {
  return {
    paper: {
      padding: theme.spacing(4),
    },
    tabs: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    fullWidth: {
      width: '100%',
    },
  };
};
// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }
class HomeSubscribe extends Component {
  constructor(props) {
    super(props);
    // this._getMySubscriptions = this._getMySubscriptions.bind(this);
    // this._getMyLiveEvent = this._getMyLiveEvent.bind(this);
    // this._getMyPastEvent = this._getMyPastEvent.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
    this.state = {
      // activeTab: 0,
      $$availableEventsByTheme: undefined,
      $$availableEventsByReference: undefined,
      $$subscriptions: undefined,
      $pastEvent: undefined,
      $liveEvent: undefined,
    };
  }
  componentDidMount() {
    this.props.onMount();
    // console.log(this.props.match)
  }
  componentDidUpdate = (oldProps) => {
    if (oldProps.$$data !== this.props.$$data && this.props.authStateKnown === true) {
      this.updateState(this.props);
    } else if (oldProps.authStateKnown !== this.props.authStateKnown && this.props.$$data !== undefined) {
      this.updateState(this.props);
    }
  };
  updateState = (props) => {
    this.setState({
      $$subscriptions: getMySubscriptions({
        $$data: props.$$data,
        userRole: props.$$user ? props.$$user.get('role') : false,
      }),
      $pastEvent: getMyPastEvents({
        $$data: props.$$data,
      }),
      $liveEvent: getMyLiveEvents({
        $$data: props.$$data,
      }),
      $$availableEventsByTheme: getAvailableEventsByTheme({
        $$data: props.$$data,
      }),
      $$availableEventsByReference: getAvailableEventsByReference({
        $$data: props.$$data,
        reference: props.match.params.referenceId,
      }),
    });
  };
  _goto = (url) => {
    const { history } = this.props;
    history.push(url);
  };
  // _handleTabChange = (event, newValue) => {
  //   this.setState({
  //     activeTab: newValue
  //   });
  // };
  // _getAvailableEventsByTheme = () => {
  //   const {
  //     $$data
  //   } = this.props;
  //   return $$data !== undefined && $$data.get("availableEvents") !== undefined ? $$data
  //     .get("availableEvents")
  //     .groupBy(($$event) => $$event.get("themeName")) : undefined;
  // };
  // _getMyLiveEvent = () => {
  //   const {
  //     $$data
  //   } = this.props;
  //   const $$subscriptions = this._getMySubscriptions();
  //   return $$subscriptions !== undefined &&
  //     $$subscriptions.size > 0 &&
  //     $$subscriptions.get(0) !== undefined ?
  //     $$data.get("myfutureevents").get(0) :
  //     undefined;
  // };
  // _getMyPastEvent = () => {
  //   const {
  //     $$data
  //   } = this.props;
  //   return $$data !== undefined &&
  //     $$data.get("mypastevents") !== undefined &&
  //     $$data.get("mypastevents").size > 0 ?
  //     $$data
  //     .get("mypastevents")
  //     .filter(
  //       ($e) =>
  //       $e.get("hasAttended") !== undefined &&
  //       $e.get("hasAttended") !== "" &&
  //       $e.get("hasAttended") !== null
  //     )
  //     .get(0) :
  //     undefined;
  // };
  // _getMySubscriptions = () => {
  //   const {
  //     userRole,
  //     $$data
  //   } = this.props;
  //   const $$subscriptions =
  //     userRole !== undefined &&
  //     $$data !== undefined &&
  //     $$data.get("myfutureevents") !== undefined ?
  //     $$data.get("myfutureevents").map((e) => e.get("id")) :
  //     Immutable.Map();
  //   return $$subscriptions;
  // };
  _gotoLiveRoom = (e) => {
    e.preventDefault();
    const $liveEvent = this._getMyLiveEvent();
    gotoLiveRoom($liveEvent, (res) => {
      if (res === true) this._goto('/live/' + $liveEvent.get('id'));
    });
  };
  _onSubscriptionComplete = () => {
    this.props.onMount();
  };
  render() {
    const {
      $$data,
      // userRole,
      $$user,
      classes,
      // onSubscriptionComplete,
    } = this.props;
    const {
      // activeTab,
      $$availableEventsByTheme,
      $$availableEventsByReference,
      $$subscriptions,
      $pastEvent,
      $liveEvent,
    } = this.state;
    const userRole = $$user !== undefined ? $$user.get('role') : 'visitor';
    // const $$tabs = Immutable.fromJS([
    //   { label: "A venir", disabled: false },
    //   { label: "En direct", disabled: true },
    //   { label: "Terminée(s)", disabled: true },
    // ]);
    // console.log($$user.toJS())
    // if($$availableEventsByReference !== undefined)
    //   console.log($$availableEventsByReference.toJS())
    // if($$availableEventsByTheme !== undefined)
    //   console.log($$availableEventsByTheme.toJS())
    return (
      <Template title={false}>
        <Grid container spacing={0}>
          <If condition={$$availableEventsByReference !== undefined}>
            {$$availableEventsByReference
              .map(($$themeData, tIdx) => {
                return (
                  <EventCardSimple
                    key={`eventcard-${tIdx}`}
                    tIdx={tIdx}
                    $$themeData={$$themeData}
                    $$subscriptions={$$subscriptions}
                    $$data={$$data}
                    $liveEvent={$liveEvent}
                    $pastEvent={$pastEvent}
                    $$user={$$user}
                    userRole={userRole}
                    showRemainingTime={true}
                    onSubscriptionComplete={this._onSubscriptionComplete}
                    gotoLiveRoom={this._gotoLiveRoom}
                  />
                );
              })
              .toArray()}
          </If>
        </Grid>
        <If
          condition={
            $$data !== undefined &&
            ($$data.get('availableEvents') === undefined || $$data.get('availableEvents').size < 1)
          }
        >
          <Box align="middle" py={6} className={classes.fullWidth}>
            <WarningIcon className={classes.inlineIcon} />
            {i18n.get('homeNoAvailableEvent')}
          </Box>
        </If>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    // error: getLoadingError(state),
    // isLoggedIn: isLoggedIn(state),
    // userRole: getCurrentUserRole(state),
    authStateKnown: isStateKnown(state),
    $$user: getCurrentUser(state),
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(
        fetchData({
          key: 'home',
          fetchUrl: config.home,
        }),
      );
    },
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HomeSubscribe)));



// WEBPACK FOOTER //
// ./src/components/Home/HomeSubscribe.jsx